import _extends from "@babel/runtime/helpers/extends";
/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { ursaColors } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import PanelIcon20 from "./PanelIcon20";
import PanelIcon24 from "./PanelIcon24";
const sizeMap = {
  20: /*#__PURE__*/React.createElement(PanelIcon20, null),
  24: /*#__PURE__*/React.createElement(PanelIcon24, null)
};
export const PanelIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    // This is the default icon color.
    color = `var(${getUrsaIconColorVarName()}, ${ursaColors.neutral800})`,
    size,
    style,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    color: color,
    ref: ref,
    size: size
  }, rest, {
    style: {
      ...style
    }
  }), sizeMap[size]);
});
PanelIcon.displayName = "PanelIcon";
//# sourceMappingURL=PanelIcon.js.map